import React, { FC } from 'react'

import { IAttachmentImageView } from '../../attachment.interface'

import '../../attachment.scss'

const AttachmentImageView: FC<IAttachmentImageView> = ({
  title,
  attachmentImages,
}) => {

  return (
    <div
      className='container'
      style={{
        maxHeight: '90vh',
        maxWidth: '90vw',
        overflowY: 'auto',
        padding: '20px',
      }}
    >
      <h1>{title}</h1>
      {attachmentImages?.map((attachmentImage, index) => (
        <div key={index} className='row image-wrapper-row'>
          <div className='col-lg-6'>
            <div className={'row'}>
              <label>Image Type:</label>
              <span className='sent-attachment-image-properties'>
                {attachmentImage?.imageTypeName}
              </span>
            </div>
            <div className={'row'}>
              {attachmentImage?.imageDateTaken && (
                <>
                  <label>Date Taken:</label>
                  <span className='sent-attachment-image-properties'>
                    {attachmentImage?.imageDateTaken?.toLocaleDateString()}
                  </span>
                </>
              )}
            </div>
            <div className={'row'}>
              <div className='sent-attachment-image-preview'>
                <img src={URL.createObjectURL(attachmentImage?.imageData)} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default AttachmentImageView
